import { CtaBanner } from '@/components/common/CtaBanner'

export function ConsultationCtaSection() {
  return (
    <CtaBanner
      title="Need a Custom Architecture or Scoping Session?"
      description="If your operational requirements don't map cleanly to standard packages, we will examine your system specifications and recommend the optimal technical strategy."
      ctaText="Schedule Architecture Discussion"
      ctaHref="/contact"
      cardSurface="1"
      maxWidth="max-w-3xl"
    />
  )
}
